export default "__VITE_ASSET__CBpgUYz8__"